/**
 * Internal-rollout gate: while a feature is being validated in production it can be limited to
 * Datanomik staff accounts. Backend authorization (roles/tasks) still applies on every endpoint —
 * this only controls FE visibility (menu, routes and tabs).
 */
export const isInternalUser = (user) =>
  !!user?.email && user.email.toLowerCase().endsWith('@datanomik.com');
